import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Users2 } from 'lucide-react';

export default function MyTeam() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">MY TEAM</h1>
        <p className="text-muted-foreground">Manage your team members</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Team Members</CardTitle>
          <CardDescription>View and manage your team</CardDescription>
        </CardHeader>
        <CardContent className="text-center py-12">
          <Users2 className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Team management coming soon</p>
          <p className="text-sm text-muted-foreground mt-2">
            Invite coaches and manage your gym staff
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
